/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { translate } from "../../../../services/translations/translations";
import React from "react";
import { scrollToAnchor } from "../../../../theme/commonStyle";
import Typography from "@mui/material/Typography";

type SummaryDetailsItemProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  value: string;
  labelPostfix?: string | null;
};

const SummaryDetailsItem = ({ caseData, fieldPath, value, labelPostfix = null }: SummaryDetailsItemProps) => {
  let label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  label = labelPostfix ? label + " " + labelPostfix : label;

  return (
    <>
      <Grid sx={{ marginTop: "1rem", fontWeight: 400 }} size={12}>
        <Box id={fieldPath} sx={scrollToAnchor} />
        {label}
      </Grid>
      <Grid size={12}>
        <Typography component="span" sx={{ textAlign: "center", mt: 5 }} dangerouslySetInnerHTML={{ __html: value }}></Typography>
      </Grid>
    </>
  );
};

export default SummaryDetailsItem;
